//Creating a functional component to return a wrapper and pass the props.children
const aux = (props) => props.children;

export default aux;


// WEBPACK FOOTER //
// ./src/hoc/Aux/Aux.js